import { createSlice } from '@reduxjs/toolkit'
import { getInitialState } from 'store/features/audio/initialState'
import reducers from 'store/features/audio/reducers'

const audioSlice = createSlice({
  name: 'audio',
  initialState: getInitialState(),
  reducers
})

export default audioSlice
